import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)<{
  isNoBorderTop?: boolean;
  isNoBorder?: boolean;
}>`
  & .ant-card-head {
    padding: 16px;
    border-bottom: none;
  }
  & .ant-card-body {
    flex: 0 1 auto;
    padding: 0;
  }
  .ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
    padding: 0px 16px 8px 16px;
    outline: none;
    border: none;
  }

  .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 1px;
    .ant-tabs-ink-bar {
      height: 1px;
    }
  }
  &.ant-card-bordered {
    border-top: ${({ isNoBorderTop }) =>
      isNoBorderTop ? 'none' : '1px solid #f0f0f0'};
    border: ${({ isNoBorder }) => (isNoBorder ? 'none' : '1px solid #f0f0f0')};
  }
`;
